.arrowMonthYear {
  margin-left: 5px;
  vertical-align: middle;
}

.MuiIconButton-root:hover {
  background: transparent;
}

.MuiPickersArrowSwitcher-root .MuiButtonBase-root {
  color: var(--text-icon-medium);
}

.custom-popper-style {
  margin-top: 6px;
}

/* Date Picker */

.MuiPickersPopper-paper {
  border-radius: var(--main-border-radius);
}

.MuiDateRangeCalendar-monthContainer,
.MuiDateRangeCalendar-container {
  width: 312px;
  padding-bottom: 12px;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.04);
}

.MuiDayCalendar-weekContainer,
.MuiDayCalendar-weekContainer {
  margin: 2px 12px;
}

.MuiPickersCalendarHeader-label {
  font-size: var(--font-sm);
  font-weight: var(--font-semi-bold);
  color: var(--text-primary);
}

.MuiDateRangePickerDay-dayOutsideRangeInterval:hover {
  background-color: #e1ebf2;
  color: var(--text-primary);
  font-size: var(--font-xs);
  font-weight: var(--font-regular);
  border-radius: 6px;
}

.MuiButtonBase-root.MuiPickersDay-root.MuiDateRangePickerDay-day.MuiDateRangePickerDay-notSelectedDate.MuiDateRangePickerDay-dayOutsideRangeInterval,
.MuiButtonBase-root.MuiPickersDay-root.Mui-selected.MuiDateRangePickerDay-day {
  border: 1px solid var(--default-light);
}

.MuiDialogActions-root {
  place-self: center;
}

.MuiDateRangeCalendar-root .MuiDialogActions-root > .MuiButton-root {
  color: var(--primary-main);
  width: 128px;
  height: 40px;
  border: 1px solid var(--primary-main);
  border-radius: var(--main-border-radius);
  margin-left: 8px;
  margin-right: 8px;
}

.MuiDateRangeCalendar-root
  .MuiDialogActions-root
  > .MuiButton-root:nth-child(2) {
  color: var(--default-light);
  background-color: var(--primary-main);
}

.MuiDateRangeCalendar-root
  .MuiDialogActions-root
  > .MuiButton-root:nth-child(2):hover {
  color: var(--default-light);
  background-color: var(--btn-hover);
}

.MuiDateRangeCalendar-root
  .MuiDialogActions-root
  > .MuiButton-root:nth-child(2):active {
  background-color: var(--primary-main);
  font-weight: var(--font-bold);
}

.MuiDateRangeCalendar-root
  .MuiDialogActions-root
  > .MuiButton-root:nth-child(1):hover {
  background-color: var(--default-light);
  border: 2px solid var(--primary-main);
}

.MuiDateRangeCalendar-root
  .MuiDialogActions-root
  > .MuiButton-root:nth-child(1):active {
  font-weight: var(--font-bold);
}

.MuiTypography-root.MuiTypography-caption.MuiDayCalendar-weekDayLabel {
  color: var(--text-icon-medium);
}

.MuiDayCalendar-weekDayLabel:nth-child(1)::after {
  content: "SUN";
  font-size: var(--font-xs);
  font-weight: var(--font-medium);
  color: var(--neutral-5);
}
.MuiDayCalendar-weekDayLabel:nth-child(2)::after {
  content: "MON";
  font-size: var(--font-xs);
  font-weight: var(--font-medium);
  color: var(--neutral-5);
}
.MuiDayCalendar-weekDayLabel:nth-child(3)::after {
  content: "TUE";
  font-size: var(--font-xs);
  font-weight: var(--font-medium);
  color: var(--neutral-5);
}
.MuiDayCalendar-weekDayLabel:nth-child(4)::after {
  content: "WED";
  font-size: var(--font-xs);
  font-weight: var(--font-medium);
  color: var(--neutral-5);
}
.MuiDayCalendar-weekDayLabel:nth-child(5)::after {
  content: "THU";
  font-size: var(--font-xs);
  font-weight: var(--font-medium);
  color: var(--neutral-5);
}
.MuiDayCalendar-weekDayLabel:nth-child(6)::after {
  content: "FRI";
  font-size: var(--font-xs);
  font-weight: var(--font-medium);
  color: var(--neutral-5);
}
.MuiDayCalendar-weekDayLabel:nth-child(7)::after {
  content: "SAT";
  font-size: var(--font-xs);
  font-weight: var(--font-medium);
  color: var(--neutral-5);
}

/* Hide the original labels */
.MuiDayCalendar-weekDayLabel {
  visibility: hidden;
  position: relative;
}

.MuiDayCalendar-weekDayLabel::after {
  visibility: visible;
  position: absolute;
}

.MuiDayCalendar-header {
    margin: 0 6px;
    justify-content: space-evenly;
}

.MuiTypography-root.MuiTypography-caption.MuiDayCalendar-weekDayLabel,
.MuiButtonBase-root.MuiPickersDay-root.MuiDateRangePickerDay-day {
  font-size: var(--font-xs);
  border-radius: 6px;
}

.MuiButtonBase-root.MuiPickersDay-root.Mui-selected.MuiDateRangePickerDay-day {
  background-color: var(--primary-main);
  font-size: var(--font-xs);
  /* font-weight: var(--font-semi-bold); */
  font-weight: var(--font-regular);
  color: var(--default-light);
  border: 1px solid var(--default-light);
}

.MuiButtonBase-root.MuiPickersDay-root.Mui-selected.MuiDateRangePickerDay-day:hover {
  background-color: #e1ebf2;
  color: var(--text-primary);
  font-size: var(--font-xs);
  font-weight: var(--font-regular);
  border: 1px solid var(--default-light);
}

.MuiButtonBase-root.MuiPickersDay-root.MuiPickersDay-today {
  background-color: var(--default-light);
  font-size: var(--font-xs);
  font-weight: var(--font-semi-bold);
  color: var(--text-primary);
  border: 1px solid var(--primary-main) !important;
}

.MuiDateRangePickerDay-dayInsideRangeInterval {
  background-color: #c2d6e5;
  font-size: var(--font-xs);
  font-weight: var(--font-regular);
  color: var(--text-primary);
  border: 1px solid var(--default-light);
  border-radius: 6px;
}

.MuiDateRangePickerDay-dayInsideRangeInterval:hover {
  background-color: #e1ebf2;
  font-size: var(--font-xs);
  font-weight: var(--font-regular);
  color: var(--text-primary);
  border: 1px solid var(--default-light);
  border-radius: 6px;
}

.MuiDateRangePickerDay-rangeIntervalPreview,
.MuiDateRangePickerDay-rangeIntervalPreview {
  background-color: var(--default-light);
}

.MuiDateRangePickerDay-root.MuiDateRangePickerDay-rangeIntervalDayHighlight,
.MuiDateRangePickerDay-root {
  background-color: var(--default-light);
}

.custom-text-field {
  width: 312px;
  position: absolute;
  top: -2px; /* adjust as needed */
  left: 5px; /* adjust as needed */
  z-index: 2;
  background-color: #ffffff;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}

.MuiPickersSlideTransition-root.MuiDayCalendar-slideTransition{
  overflow-y: hidden;
  min-height: 210px;
  transition: min-height 0.1s ease;
}

.MuiPickersSlideTransition-root.MuiDayCalendar-slideTransition:has(
    div > div.MuiDayCalendar-weekContainer:nth-child(6)
  ){
  min-height: 255px;
  transition: min-height 0.1s ease-in-out;
}

.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.Muifocused.MuiInputBase-formControl.MuiInputBase-adornedStart.MuiInputBase-arornedEnd,
.MuiInputBase-root-MuiOutlinedInput-root {
  border-radius: 10px;
}

.MuiDateRangePickerDay-rangeIntervalPreview.MuiDateRangerPickerDay-rangeIntervalDayPreview,
.MuiDateRangePickerDay-rangeIntervalPreview {
  border: 2px dashed var(--default-light);
}

.MuiDateRangePickerDay-rangeIntervalPreview.MuiDateRangePickerDay-rangeIntervalDayPreview.MuiDateRangePickerDay-rangeIntervalDayPreviewStart,
.MuiDateRangePickerDay-rangeIntervalPreview {
  border: 2px none var(--default-light);
}

.MuiPickersPopper-root {
  top: 6px !important;
}

.date-label {
  top: -30px;
  position: absolute;
  z-index: 1000;
  right: 270px;
  font-size: var(--font-sm);
  font-weight: var(--font-regular);
  color: var(--text-primary);
  margin-bottom: 6px;
}

.MuiDayCalendar-weekContainer,
.MuiDayCalendar-weekContainer {
  margin: 6px 6px;
  justify-content: space-evenly;
}

.datepicker-calendar-icon path {
  fill: var(--secondary-10);
}
